import { ApprovingInvoiceReportFormInputResponse } from 'ap-openapi';
import { FC, memo } from 'react';

type DefaultFieldViewProps = {
  item: ApprovingInvoiceReportFormInputResponse;
};

export const DefaultFieldView: FC<DefaultFieldViewProps> = memo(({ item }) => {
  return <div>{item?.input_values?.[0]?.label ?? ''}</div>;
});

DefaultFieldView.displayName = 'DefaultFieldView';
